import { useTranslation } from "@outschool/localization";
import React from "react";

import PageModal from "../PageModal";
import LocalizationPickerMenu from "./LocalizationPickerMenu";

const LocalizationPickerModal = ({ open, onClose }) => {
  const { t } = useTranslation(
    "client\\components\\localization\\LocalizationPickerModal"
  );
  const heading = t`Update regional settings`;

  return (
    <PageModal
      open={open}
      onClose={onClose}
      ariaLabel={heading}
      sx={{ maxWidth: 500, maxHeight: "100vh" }}
    >
      <LocalizationPickerMenu
        isOpen={true}
        onClose={onClose}
        heading={heading}
      />
    </PageModal>
  );
};

export default LocalizationPickerModal;
